export default __webpack_public_path__ + "static/media/Address-Label1.42481d48.png";